import React from 'react';
import {
  Drawer,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Components
import DrawerHeader from './DrawerHeader';
import AppNavigation from './AppNavigation';

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'width',
})(({ theme, width }) => ({
  '& .MuiDrawer-paper': {
    width: width,
    padding: theme.spacing(2, 2),
    boxSizing: 'border-box',
    border: 'none',
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
}));

const DrawerContent = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
}));

export default function MainDrawer({
  width = 280,
  open = true,
  mobileOpen = false,
  onMobileClose,
  isMobile = false,
}) {
  const theme = useTheme();
  
  const drawerContent = (
    <DrawerContent>
      <DrawerHeader />
      {/* Replace NavigationList with your new tree structure */}
      <AppNavigation onItemClick={isMobile ? onMobileClose : undefined} />
    </DrawerContent>
  );

  return (
    <>
      {/* Mobile Drawer */}
      <StyledDrawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        width={width}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
        }}
      >
        {drawerContent}
      </StyledDrawer>

      {/* Desktop Drawer */}
      <StyledDrawer
        variant="persistent"
        open={open}
        width={width}
        sx={{
          display: { xs: 'none', md: 'block' },
        }}
      >
        {drawerContent}
      </StyledDrawer>
    </>
  );
}